const t = "Action", n = "Add annotation at {{time}}", o = "Add quiz at {{time}}", e = "Annotations", s = "Auto ({{quality}})", c = "Back", E = "Captions", A = "Disable Captions", a = "Enable Captions", T = "Caption Language", _ = "Manage Captions", O = "Delete {{language}}", S = "Font Size", N = "Caption Language: {{language}}", P = "Close", C = "Comments", L = "Continue", i = "Decrease Playback Speed", u = "Decrease Volume by {{percent}}%", I = "Down Arrow", U = "Enter Fullscreen", l = "Exit Fullscreen", R = "Increase Playback Speed", p = "Increase Volume by {{percent}}%", r = "Invert Colors", D = "Jump to specific percentage (1-10%, 2-20%, etc)", M = "Jump to Start", g = "Actions for {{title}}", d = "Keyboard Shortcuts", G = "Language", m = "Left Arrow", y = "Main Menu", B = "Mute", V = "Muted", b = "Next Caption Language", K = "Off", Y = "On Top", k = "Open annotation at {{time}}", F = "Open completed quiz at {{time}}", f = "Open quiz at {{time}}", w = "Pause", Q = "Play", W = "Playback Speed", q = "Playback Speed: {{speed}}x", x = "Previous Caption Language", z = "Quality", J = "Quality Menu", Z = "Replay", h = "Reset Playback Speed", v = "Right Arrow", H = "Seek backward: {{seconds}} seconds", X = "Seek forward: {{seconds}} seconds", j = "Settings", $ = "Shortcut", tt = "Space", nt = "Playback speed menu", ot = "Toggle Captions", et = "Toggle Muted", st = "Toggle Play/Pause", ct = "Up Arrow", Et = "Video Settings", At = "Volume", at = "Volume: {{volume}}%", Tt = {
  ACTION: t,
  ADD_ANNOTATION_AT: n,
  ADD_QUIZ_AT: o,
  ANNOTATIONS: e,
  AUTO: s,
  BACK: c,
  CAPTIONS: E,
  CAPTIONS_DISABLE: A,
  CAPTIONS_ENABLE: a,
  CAPTIONS_LANGUAGE: T,
  CAPTIONS_MANAGE: _,
  CAPTION_DELETE: O,
  CAPTION_FONT_SIZE: S,
  CAPTION_LANGUAGE: N,
  CLOSE: P,
  COMMENTS: C,
  CONTINUE: L,
  DECREASE_PLAYBACK_SPEED: i,
  DECREASE_VOLUME: u,
  DOWN_ARROW: I,
  ENTER_FULLSCREEN: U,
  EXIT_FULLSCREEN: l,
  INCREASE_PLAYBACK_SPEED: R,
  INCREASE_VOLUME: p,
  INVERT_COLORS: r,
  JUMP_TO_PERCENTAGE: D,
  JUMP_TO_START: M,
  KEBAB_MENU: g,
  KEYBOARD_SHORTCUTS: d,
  LANGUAGE: G,
  LEFT_ARROW: m,
  MAIN_MENU: y,
  MUTE: B,
  MUTED: V,
  NEXT_CAPTION_LANGUAGE: b,
  OFF: K,
  ON_TOP: Y,
  OPEN_ANNOTATION_AT: k,
  OPEN_COMPLETED_QUIZ_AT: F,
  OPEN_QUIZ_AT: f,
  PAUSE: w,
  PLAY: Q,
  PLAYBACK_SPEED: W,
  PLAYBACK_SPEED_MESSAGE: q,
  PREVIOUS_CAPTION_LANGUAGE: x,
  QUALITY: z,
  QUALITY_MENU: J,
  REPLAY: Z,
  RESET_PLAYBACK_SPEED: h,
  RIGHT_ARROW: v,
  SEEK_BACKWARD: H,
  SEEK_FORWARD: X,
  SETTINGS: j,
  SHORTCUT: $,
  SPACE: tt,
  SPEED_MENU: nt,
  TOGGLE_CAPTIONS: ot,
  TOGGLE_MUTED: et,
  TOGGLE_PLAY_PAUSE: st,
  UP_ARROW: ct,
  VIDEO_SETTINGS: Et,
  VOLUME: At,
  VOLUME_VALUE: at
};
export {
  t as ACTION,
  n as ADD_ANNOTATION_AT,
  o as ADD_QUIZ_AT,
  e as ANNOTATIONS,
  s as AUTO,
  c as BACK,
  E as CAPTIONS,
  A as CAPTIONS_DISABLE,
  a as CAPTIONS_ENABLE,
  T as CAPTIONS_LANGUAGE,
  _ as CAPTIONS_MANAGE,
  O as CAPTION_DELETE,
  S as CAPTION_FONT_SIZE,
  N as CAPTION_LANGUAGE,
  P as CLOSE,
  C as COMMENTS,
  L as CONTINUE,
  i as DECREASE_PLAYBACK_SPEED,
  u as DECREASE_VOLUME,
  I as DOWN_ARROW,
  U as ENTER_FULLSCREEN,
  l as EXIT_FULLSCREEN,
  R as INCREASE_PLAYBACK_SPEED,
  p as INCREASE_VOLUME,
  r as INVERT_COLORS,
  D as JUMP_TO_PERCENTAGE,
  M as JUMP_TO_START,
  g as KEBAB_MENU,
  d as KEYBOARD_SHORTCUTS,
  G as LANGUAGE,
  m as LEFT_ARROW,
  y as MAIN_MENU,
  B as MUTE,
  V as MUTED,
  b as NEXT_CAPTION_LANGUAGE,
  K as OFF,
  Y as ON_TOP,
  k as OPEN_ANNOTATION_AT,
  F as OPEN_COMPLETED_QUIZ_AT,
  f as OPEN_QUIZ_AT,
  w as PAUSE,
  Q as PLAY,
  W as PLAYBACK_SPEED,
  q as PLAYBACK_SPEED_MESSAGE,
  x as PREVIOUS_CAPTION_LANGUAGE,
  z as QUALITY,
  J as QUALITY_MENU,
  Z as REPLAY,
  h as RESET_PLAYBACK_SPEED,
  v as RIGHT_ARROW,
  H as SEEK_BACKWARD,
  X as SEEK_FORWARD,
  j as SETTINGS,
  $ as SHORTCUT,
  tt as SPACE,
  nt as SPEED_MENU,
  ot as TOGGLE_CAPTIONS,
  et as TOGGLE_MUTED,
  st as TOGGLE_PLAY_PAUSE,
  ct as UP_ARROW,
  Et as VIDEO_SETTINGS,
  At as VOLUME,
  at as VOLUME_VALUE,
  Tt as default
};
